import { render, staticRenderFns } from "./AccountLineProductPermissionsModal.vue?vue&type=template&id=10c4a7ab&scoped=true&"
import script from "./AccountLineProductPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./AccountLineProductPermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountLineProductPermissionsModal.vue?vue&type=style&index=0&id=10c4a7ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4a7ab",
  null
  
)

export default component.exports